import _ from 'lodash';
import { connect } from 'react-redux';

import ChatUsersMapView from './view.jsx';
import { trackAdoptionMetricsForMapFilterAppliedEvent } from 'src/legacy/redux/actions/adoption.jsx';

const mapStateToProps = (state) => {
  return {
    loading: _.get(state.legacyRootReducer, 'chatUser.locations.loading'),
    locations: _.get(state.legacyRootReducer, 'chatUser.locations.items')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    //send map
    trackAdoptionMetricsForMapFilterAppliedEvent: (filter) => {
      return dispatch(trackAdoptionMetricsForMapFilterAppliedEvent(filter));
    }
  }
}

const ChatUsersMapContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatUsersMapView);

export default ChatUsersMapContainer;